export default defineNuxtRouteMiddleware(async (to) => {
  const { user, loggedIn } = useUserSession()
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value
  const byhoursConnect = useCookie('byhours_connect')
  const authStore = useAuthStore()

  // Si el usuario está logueado y va a search o user-zone, verificar/refrescar token
  if (loggedIn.value && (to.path.includes('/user-zone') || to.path.includes('/search'))) {
    await authStore.getValidToken()
  }

  // Si el usuario no está logueado y va a una página de user-zone, redirigir a login
  if (!user.value && to.path.includes('/user-zone')) {
    return navigateTo({ path: `/${locale}/login`, query: to.query })
  }

  // Si el usuario está logueado y va a la página de login, redirigir a user-zone
  if (user.value && to.path.includes('/login')) {
    return navigateTo({ path: `/${locale}/user-zone`, query: to.query })
  }

  // Sesión Nuxt sin token Byhours: limpiar todo el estado de cliente y redirigir
  if (loggedIn.value && !byhoursConnect.value) {
    await authStore.clearAllUserClientState()
    return navigateTo(`/${locale}`)
  }
})